export function toSearchParams(obj) {
    const def = Object.entries(obj)
        .filter(([_, value]) => value !== undefined && value !== null)
        .map(([key, value]) => [key, String(value)]);
    return new URLSearchParams(def);
}
